<template>
    <foto-vuestic-modal ref="modal" v-bind:small="false" :cancelClass="'none'" okClass="none">
      <div slot="title">Aviso Importante!</div>
      <div slot="body">
        <p>Durante as aulas, algumas fotos serão tiradas automaticamente para validar sua presença.</p>
      </div>
      <div slot="footer">
          <button type="button" @click="closeModal()" class="btn-primary btnmodal">Ok</button>
      </div>
    </foto-vuestic-modal>
</template>
<script>

    export default {
        name: 'aviso-de-fotos',
        data: () => {
            return {

            }
        },
        mounted () {
            if(sessionStorage.getItem('aviso') === null)
            {
                this.$refs.modal.open('');
                sessionStorage.setItem('aviso', true);
            }
        },
        methods: {
            closeModal() {
                this.$refs.modal.close('');
            }
        }
    }
    
</script>

